import { TileIndex } from "../../types";

export const ORDER_MATTERS_LEVEL: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 1, 2, 2, 2, 2, 2, 2, 1],
  [1, 0, 2, 2, 0, 1, 9, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 2, 1],
  [1, 0, 0, 5, 0, 11, 0, 0, 0, 0, 0, 0, 9, 3, 1, 1, 1, 1, 10, 1],
  [1, 1, 1, 1, 1, 1, 0, 12, 0, 7, 0, 19, 1, 1, 1, 1, 15, 0, 0, 1],
  [1, 0, 0, 7, 0, 11, 0, 0, 0, 0, 0, 0, 9, 0, 1, 1, 1, 1, 0, 1],
  [1, 0, 2, 2, 0, 1, 9, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1],
  [1, 0, 0, 0, 0, 1, 6, 5, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
]